export default __webpack_public_path__ + "static/media/NEW_cheese_pic.e4ae72f0.jpeg";